module.exports = __webpack_public_path__ + "static/img/warehousing.f906a435.png";